import React from 'react'

import useOrderList from '@src/hooks/order/useOrderList'

import { formatPhoneNumber, getDateByTimezone, formatPriceByLocale } from '@src/utils/utils'

import ExcelDownLoad from '@src/components/order/list/ExcelDownLoad'
import TableSection from '@src/components/order/list/TableSection'
import TableHeader from '@src/components/order/list/TableHeader'
import TableRowData from '@src/components/order/list/TableRowData'
import OrderNum from '@src/components/order/list/OrderNum'
import TrackingNum from '@src/components/order/list/TrackingNum'

type OrderListProps = {
	itemPerPage: number
	currentPage: number
}

const OrderList = ({ itemPerPage, currentPage }: OrderListProps) => {
	const {
		orderItemList,
		handleChangeTackingNoByOrderItem,
		handleClickTrackingNoSave,
		handleClickTrackingNoModify,
		handleClickDownload,
	} = useOrderList(itemPerPage, currentPage)

	const headerData = [
		{ value: '주문일시', width: 10 },
		{ value: '주문번호/토스', width: 13.2 },
		{ value: '주문자', width: 8.1 },
		{ value: '수령인', width: 8.1 },
		{ value: '수령인 연락처', width: 11 },
		{ value: '상품명', width: 18 },
		{ value: '옵션', width: 8.8 },
		{ value: '수량', width: 4 },
		{ value: '택배사', width: 8 },
		{ value: '운송번호', width: 12 },
		{ value: '배송지', width: 10 },
		{ value: '상세주소', width: 10 },
		{ value: '결제금액', width: 7 },
	]

	return (
		<>
			<ExcelDownLoad onDownload={handleClickDownload} />
			<TableSection>
				<TableHeader datas={headerData} />
				<tbody>
					{orderItemList
						.filter((orderItem) => orderItem.order)
						.map((orderItem, index) => (
							<tr style={{ height: '5rem' }} key={`order-item-no-${orderItem.no}`}>
								<TableRowData align="center">
									{getDateByTimezone(
										'Asia/Seoul',
										'yyyy-MM-dd HH:mm:dd',
										orderItem.order.create_date,
									)
										.split(' ')
										.join('\n')}
								</TableRowData>
								<TableRowData align="center">
									<OrderNum
										orderNo={orderItem.order.no}
										tossCode={orderItem.order.order_toss_record.toss_order_id}
									/>
								</TableRowData>
								<TableRowData align="center">{orderItem.order.user.nickname}</TableRowData>
								<TableRowData align="center">
									{orderItem.order.order_shipping.recipient}
								</TableRowData>
								<TableRowData align="center">
									{formatPhoneNumber(orderItem.order.order_shipping.phone)}
								</TableRowData>
								<TableRowData align="center">{orderItem.archived_product.title}</TableRowData>
								<TableRowData align="center">
									{orderItem.archived_sku.name ? orderItem.archived_sku.name : '-'}
								</TableRowData>
								<TableRowData align="center">{orderItem.quantity}</TableRowData>
								<TableRowData align="center">
									{orderItem.order_item_tracking?.courier_name
										? orderItem.order_item_tracking.courier_name
										: '-'}
								</TableRowData>
								<TableRowData align="center">
									{orderItem.order_item_tracking?.tracking_no ? (
										<TrackingNum
											trackingNo={orderItem.order_item_tracking.tracking_no}
											onClick={() => handleClickTrackingNoModify(orderItem.no)}
										/>
									) : (
										<TrackingNum
											onChange={(e) => handleChangeTackingNoByOrderItem(e, orderItem.no)}
											onClick={() => handleClickTrackingNoSave(orderItem.no)}
										/>
									)}
								</TableRowData>
								<TableRowData align="center">
									{orderItem.order.order_shipping.address1}
								</TableRowData>
								<TableRowData align="center">
									{orderItem.order.order_shipping.address2}
								</TableRowData>
								<TableRowData align="center">
									{formatPriceByLocale(orderItem.order.total_price, 'ko')}
								</TableRowData>
							</tr>
						))}
				</tbody>
			</TableSection>
		</>
	)
}

export default OrderList
